import React, { useState } from 'react';
import TeamLeaveCards from './TeamLeaveCards';
import LeavesHistory from './LeavesHistory';

const LeaveManagement = () => {
  const [activeTab, setActiveTab] = useState('team');

  const tabConfig = [
    { key: 'team', label: 'pending Requests' },
    { key: 'leave', label: 'History' },
  ];

  const componentMap = {
    team: <TeamLeaveCards />,
    leave: <LeavesHistory/>,
  };

  return (
    <div className="w-full p-4">
      {/* Tab Buttons aligned to ends */}
      <div className="flex justify-between border-b mb-4">
        {tabConfig.map((tab) => (
          <button
            key={tab.key}
            className={`text-sm uppercase font-semibold pb-2 px-4 tracking-wider ${
              activeTab === tab.key
                ? 'border-b-2 border-green-500 text-green-600'
                : 'text-gray-500'
            }`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Active Tab Content */}
      <div>{componentMap[activeTab]}</div>
    </div>
  );
};

export default LeaveManagement;
